/**
 * Modal-lightbox for viewing payment screenshots (image or PDF).
 * Click backdrop or × to close.
 */
const ScreenshotLightbox = ({ url, onClose }) => {
  if (!url) return null;
  const isPdf = url.endsWith('.pdf');
  return (
    <div className="fixed inset-0 bg-black/80 z-[60] flex items-center justify-center p-4" onClick={onClose}>
      <div className="relative max-w-3xl max-h-[90vh] w-full flex items-center justify-center" onClick={(e) => e.stopPropagation()}>
        {isPdf ? (
          <iframe src={url} title="Payment proof" className="w-full h-[80vh] rounded-xl bg-white" />
        ) : (
          <img src={url} alt="Payment screenshot" className="max-w-full max-h-[85vh] rounded-xl" data-testid="payment-screenshot-image" />
        )}
        <button
          onClick={onClose}
          className="absolute -top-3 -right-3 bg-white rounded-full w-8 h-8 flex items-center justify-center text-gray-900 shadow-lg"
          aria-label="Close"
        >
          ×
        </button>
      </div>
    </div>
  );
};

export default ScreenshotLightbox;
